export const getSelectedTeamMemberName = (
  selectedTeamMembers,
  currentTeam,
  userUuid,
) => {
  if (!selectedTeamMembers?.[0]) return "";

  if (selectedTeamMembers.length > 1) {
    return "All";
  }

  if (selectedTeamMembers[0] === userUuid) {
    return "You";
  }

  const selectedMember = currentTeam?.users?.find(
    (user) => user.uuid === selectedTeamMembers[0],
  );

  return selectedMember
    ? `${
        selectedMember.roleId === 1
          ? "Dr"
          : selectedMember.firstName.substring(0, 1)
      }. ${selectedMember.lastName}`
    : "";
};
